/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TechStackInstallDto } from '../models/tech-stack-install-dto';

@Injectable({
  providedIn: 'root',
})
export class InstallService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getInstall
   */
  static readonly GetInstallPath = '/installs/{companyId}/{productId}';

  /**
   * Get Install.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInstall()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInstall$Response(params: {
    companyId: string;
    productId: string;
  }): Observable<StrictHttpResponse<TechStackInstallDto>> {

    const rb = new RequestBuilder(this.rootUrl, InstallService.GetInstallPath, 'get');
    if (params) {
      rb.path('companyId', params.companyId, {});
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackInstallDto>;
      })
    );
  }

  /**
   * Get Install.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInstall$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInstall(params: {
    companyId: string;
    productId: string;
  }): Observable<TechStackInstallDto> {

    return this.getInstall$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackInstallDto>) => r.body as TechStackInstallDto)
    );
  }

  /**
   * Path part for operation updateInstall
   */
  static readonly UpdateInstallPath = '/installs/{companyId}/{productId}';

  /**
   * Update Install.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInstall()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInstall$Response(params: {
    companyId: string;
    productId: string;
    body: TechStackInstallDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InstallService.UpdateInstallPath, 'put');
    if (params) {
      rb.path('companyId', params.companyId, {});
      rb.path('productId', params.productId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update Install.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateInstall$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInstall(params: {
    companyId: string;
    productId: string;
    body: TechStackInstallDto
  }): Observable<void> {

    return this.updateInstall$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteInstall
   */
  static readonly DeleteInstallPath = '/installs/{companyId}/{productId}';

  /**
   * Delete Install.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInstall()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInstall$Response(params: {
    companyId: string;
    productId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InstallService.DeleteInstallPath, 'delete');
    if (params) {
      rb.path('companyId', params.companyId, {});
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete Install.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteInstall$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInstall(params: {
    companyId: string;
    productId: string;
  }): Observable<void> {

    return this.deleteInstall$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
